// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LayoutRouteImport } from './routes/_layout'
import { Route as ConfirmEmailRouteImport } from './routes/confirm-email'
import { Route as PrivacyPolicyRouteImport } from './routes/privacy-policy'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as SigninRouteImport } from './routes/signin'
import { Route as SignupRouteImport } from './routes/signup'
import { Route as SignupEmailRouteImport } from './routes/signup-email'
import { Route as TermsOfServiceRouteImport } from './routes/terms-of-service'
import { Route as UpdatePasswordRouteImport } from './routes/update-password'
import { Route as LayoutIndexRouteImport } from './routes/_layout/index'
import { Route as LayoutSplatRouteImport } from './routes/_layout/$'
import { Route as LayoutAuthRouteImport } from './routes/_layout/_auth'
import { Route as LayoutSubscriptionRouteImport } from './routes/_layout/subscription'
import { Route as LayoutAuthHistoryRouteImport } from './routes/_layout/_auth/history'
import { Route as LayoutAuthSettingsRouteImport } from './routes/_layout/_auth/settings'
import { Route as LayoutShareIdRouteImport } from './routes/_layout/share/$id'
import { Route as LayoutAuthEditorIdRouteImport } from './routes/_layout/_auth/editor/$id'

const LayoutRoute = LayoutRouteImport.update({
            id: '/_layout',getParentRoute: () => rootRouteImport
          })
const ConfirmEmailRoute = ConfirmEmailRouteImport.update({
            id: '/confirm-email',path: '/confirm-email',getParentRoute: () => rootRouteImport
          })
const PrivacyPolicyRoute = PrivacyPolicyRouteImport.update({
            id: '/privacy-policy',path: '/privacy-policy',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const SigninRoute = SigninRouteImport.update({
            id: '/signin',path: '/signin',getParentRoute: () => rootRouteImport
          })
const SignupRoute = SignupRouteImport.update({
            id: '/signup',path: '/signup',getParentRoute: () => rootRouteImport
          })
const SignupEmailRoute = SignupEmailRouteImport.update({
            id: '/signup-email',path: '/signup-email',getParentRoute: () => rootRouteImport
          })
const TermsOfServiceRoute = TermsOfServiceRouteImport.update({
            id: '/terms-of-service',path: '/terms-of-service',getParentRoute: () => rootRouteImport
          })
const UpdatePasswordRoute = UpdatePasswordRouteImport.update({
            id: '/update-password',path: '/update-password',getParentRoute: () => rootRouteImport
          })
const LayoutIndexRoute = LayoutIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LayoutRoute
          })
const LayoutSplatRoute = LayoutSplatRouteImport.update({
            id: '/$',path: '/$',getParentRoute: () => LayoutRoute
          })
const LayoutAuthRoute = LayoutAuthRouteImport.update({
            id: '/_auth',getParentRoute: () => LayoutRoute
          })
const LayoutSubscriptionRoute = LayoutSubscriptionRouteImport.update({
            id: '/subscription',path: '/subscription',getParentRoute: () => LayoutRoute
          })
const LayoutAuthHistoryRoute = LayoutAuthHistoryRouteImport.update({
            id: '/history',path: '/history',getParentRoute: () => LayoutAuthRoute
          })
const LayoutAuthSettingsRoute = LayoutAuthSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => LayoutAuthRoute
          })
const LayoutShareIdRoute = LayoutShareIdRouteImport.update({
            id: '/share/$id',path: '/share/$id',getParentRoute: () => LayoutRoute
          })
const LayoutAuthEditorIdRoute = LayoutAuthEditorIdRouteImport.update({
            id: '/editor/$id',path: '/editor/$id',getParentRoute: () => LayoutAuthRoute
          })





const LayoutAuthRouteChildren = {
  LayoutAuthHistoryRoute: LayoutAuthHistoryRoute,LayoutAuthSettingsRoute: LayoutAuthSettingsRoute,LayoutAuthEditorIdRoute: LayoutAuthEditorIdRoute
}

const LayoutAuthRouteWithChildren = LayoutAuthRoute._addFileChildren(LayoutAuthRouteChildren)



const LayoutRouteChildren = {
  LayoutSplatRoute: LayoutSplatRoute,LayoutAuthRoute: LayoutAuthRouteWithChildren,LayoutSubscriptionRoute: LayoutSubscriptionRoute,LayoutIndexRoute: LayoutIndexRoute,LayoutShareIdRoute: LayoutShareIdRoute
}

const LayoutRouteWithChildren = LayoutRoute._addFileChildren(LayoutRouteChildren)

const rootRouteChildren = {
  LayoutRoute: LayoutRouteWithChildren,ConfirmEmailRoute: ConfirmEmailRoute,PrivacyPolicyRoute: PrivacyPolicyRoute,ResetPasswordRoute: ResetPasswordRoute,SigninRoute: SigninRoute,SignupRoute: SignupRoute,SignupEmailRoute: SignupEmailRoute,TermsOfServiceRoute: TermsOfServiceRoute,UpdatePasswordRoute: UpdatePasswordRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)